import { Link } from "react-router-dom";
import type { MediaTitle } from "@/types/media";
import { formatHeat } from "@/lib/media";

interface PosterCardProps {
  item: MediaTitle;
}

export default function PosterCard({ item }: PosterCardProps) {
  const yearLabel =
    item.type === "tv" && item.endYear
      ? `${item.year}-${item.endYear}`
      : `${item.year}`;

  return (
    <Link
      to={`/detail/${item.id}`}
      data-product-shop
      className="group block card-hover"
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title} 海报`}
          title={`${item.title} ${item.genres.join(" ")} 影视详情`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent opacity-90" />
        <div className="absolute top-2 left-2 flex items-center gap-1">
          <span className="px-1.5 py-0.5 rounded-md text-[10px] font-medium bg-primary-500/90 text-background-50 backdrop-blur-sm">
            {item.region}
          </span>
          {item.type === "tv" && item.status && (
            <span
              className={`px-1.5 py-0.5 rounded-md text-[10px] font-medium backdrop-blur-sm ${
                item.status === "连载"
                  ? "bg-accent-500/90 text-background-50"
                  : "bg-secondary-500/90 text-background-50"
              }`}
            >
              {item.status}
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-2.5">
          <h3 className="text-sm font-semibold text-background-50 truncate">
            {item.title}
          </h3>
          <div className="mt-1 flex items-center justify-between">
            <span className="text-[11px] text-background-200">{yearLabel}</span>
            <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-accent-400">
              <i className="ri-fire-fill" />
              {formatHeat(item.heat)}
            </span>
          </div>
        </div>
      </div>
      <div className="mt-2 flex items-center justify-between px-0.5">
        <span className="text-[11px] text-foreground-500 truncate">
          {item.genres.slice(0, 2).join(" · ")}
        </span>
        <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-accent-600 whitespace-nowrap">
          <i className="ri-star-fill text-[10px]" />
          {item.rating.toFixed(1)}
        </span>
      </div>
    </Link>
  );
}